export default "images/红绿灯提示-红灯.png";